import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/gva_web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/gva_web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getFileRoleList, getFileRoleByName, createFileRole, updateFileRole, deleteFileRole, batchDelFileRoleByIds } from "@/api/file_role";
import infoList from "@/components/mixins/infoList";
import { getCookie } from "@/utils/cookie";
import { mapGetters } from 'vuex';
import FileRoleUser from "@/view/report/file/components/fileRoleUser";
import Folder from "@/view/report/file/components/fileRoleFolder";
var permissionOptions = ['Download', 'Upload', 'Delete'];
export default {
  name: "FileRole",
  mixins: [infoList],
  computed: _objectSpread({}, mapGetters('user', ['userInfo', 'token'])),
  components: {
    FileRoleUser: FileRoleUser,
    Folder: Folder
  },
  data: function data() {
    return {
      listApi: getFileRoleList,
      checkAll: false,
      checkedPermissions: [],
      permissions: permissionOptions,
      isIndeterminate: false,
      fileRole: {},
      selectItemFlag: false,
      drawer: false,
      activeRow: {},
      ruleForm: {
        groupName: null,
        permission: null
      },
      loading: false,
      title: "Add",
      userId: parseInt(getCookie("userId")),
      formData: {
        groupName: null,
        permission: null,
        createdBy: '',
        updatedBy: ''
      },
      path: "",
      deletepath: "",
      selected: [],
      dialogFormVisible: false,
      rules: {
        groupName: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }]
        //permission: [{required: true, message: '请选择权限类型', trigger: 'change'}]
      }
    };
  },
  created: function () {
    var _created = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return this.getTableData();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  methods: {
    handleClick: function handleClick(tab, e) {
      if (tab.index == 0) {}
      if (tab.index == 1) {}
    },
    saveFileWithUsers: function () {
      var _saveFileWithUsers = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this = this;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              Promise.all([this.$refs["fileRoleUser"].saveFileRoleWithUsers(), this.$refs["fileRoleFolder"].saveFileRoleWithFolders()]).then(function (res) {
                var isFailedItem = [];
                res.forEach(function (response) {
                  if (response.code !== 0) {
                    isSuccess = false;
                    isFailedItem.push(response);
                  }
                });
                if (isFailedItem.length > 0) {
                  // 存在失败的
                  _this.$message.error(isFailedItem[0].message);
                } else {
                  _this.$message.success("operate Success !!");
                }
              });
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function saveFileWithUsers() {
        return _saveFileWithUsers.apply(this, arguments);
      }
      return saveFileWithUsers;
    }(),
    getFolderListFunc: function () {
      var _getFolderListFunc = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 1;
              return getFolderList();
            case 1:
              res = _context3.sent;
              if (res.code == 0) {} else {
                this.$message.error(res.msg);
              }
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getFolderListFunc() {
        return _getFolderListFunc.apply(this, arguments);
      }
      return getFolderListFunc;
    }(),
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedPermissions = val ? permissionOptions : [];
      this.isIndeterminate = false;
      if (val) {
        this.formData.permission = 7;
      } else {
        this.formData.permission = 0;
      }
      console.log('is checkAll', this.checkAll);
    },
    handleCheckedpermissionsChange: function handleCheckedpermissionsChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.permissions.length;
      // console.log('is checkAll',this.checkAll);
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.permissions.length;
      var num = 0;
      var arr = this.checkedPermissions;
      if (arr.length > 0) {
        var _iterator = _createForOfIteratorHelper(arr),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var i = _step.value;
            // console.log(i);
            if ('Download' == i) {
              num += 1;
            } else if ('Upload' == i) {
              num += 2;
            } else if ('Delete' == i) {
              num += 4;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      this.formData.permission = num;
      // console.log(this.formData.permission);
    },
    filterMethod: function filterMethod() {},
    openDrawer: function openDrawer(row) {
      this.drawer = true;
      this.activeRow = row;
    },
    resetForm: function () {
      var _resetForm = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(formName) {
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.$refs[formName].resetFields();
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function resetForm(_x) {
        return _resetForm.apply(this, arguments);
      }
      return resetForm;
    }(),
    selectFunc: function selectFunc(selected) {
      if (selected) {
        this.selected = selected;
      }
    },
    handleExpandChange: function handleExpandChange(row, expanded) {
      if (expanded) {
        // 当前是展开状态
        if (this.hasLoad) {
          // 已执行过load，则去掉执行过的标记
          this.hasLoad = false;
        } else {
          // 不然，则执行load。因为load只会执行一次，所以需要在expand事件触发再次执行
          this.load(this.currentLoadTreeData, '', this.resolveObj);
        }
      }
    },
    load: function () {
      var _load = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(tree, treeNode, resolve) {
        var res, _t;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              // 标记当前已执行load
              this.hasLoad = true;
              this.loading = true;
              _context5.prev = 1;
              this.currentLoadTreeData = tree;
              // 缓存当前的resolve
              this.resolveObj = resolve;
              this.formData = {};
              this.formData.pid = tree.ID;
              _context5.next = 2;
              return getSubFolderByPid(this.formData);
            case 2:
              res = _context5.sent;
              if (res.code == 0) {
                resolve(res.data.folders);
              }
              _context5.next = 4;
              break;
            case 3:
              _context5.prev = 3;
              _t = _context5["catch"](1);
            case 4:
              _context5.prev = 4;
              this.loading = false;
              return _context5.finish(4);
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[1, 3, 4, 5]]);
      }));
      function load(_x2, _x3, _x4) {
        return _load.apply(this, arguments);
      }
      return load;
    }(),
    editOpen: function editOpen(row) {
      this.dialogFormVisible = true;
      this.formData.pid = row.ID;
      this.formData.folderType = row.folderType;
      this.selectItemFlag = true;
    },
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    handleClose: function handleClose() {
      this.path = "";
      this.formData.name = "";
      this.formData.folderType = null;
      this.dialogFormVisible = false;
    },
    createFolderFunc: function createFolderFunc() {
      this.title = "Add";
      this.selectItemFlag = false;
      this.formData = {};
      this.formData.ID = null;
      this.formData.createdBy = this.userInfo.nickName;
      this.dialogFormVisible = true;
      this.checkedPermissions = [];
      this.isIndeterminate = false;
      this.checkAll = false;
    },
    createFolderRowFunc: function createFolderRowFunc(row) {
      this.path += row.name + "/";
      this.formData.folderType = "" + row.folderType;
      this.title = "Add";
      this.selectItemFlag = true;
      this.formData.level = '2';
      this.formData.ID = null;
      this.formData.pid = row.ID;
      this.formData.isFolder = true;
      this.formData.createdBy = this.userInfo.nickName;
      this.dialogFormVisible = true;
    },
    editFileRole: function () {
      var _editFileRole = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(row) {
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              // console.log(JSON.stringify(row));
              this.title = "Edit";
              this.dialogFormVisible = true;
              this.formData.ID = row.ID;
              this.formData.groupName = row.groupName;
              if (row.permission == 1) {
                this.checkedPermissions = ['Download'];
              } else if (row.permission == 2) {
                this.checkedPermissions = ['Upload'];
              } else if (row.permission == 3) {
                this.checkedPermissions = ['Download', 'Upload'];
              } else if (row.permission == 4) {
                this.checkedPermissions = ['Delete'];
              } else if (row.permission == 5) {
                this.checkedPermissions = ['Download', 'Delete'];
              } else if (row.permission == 6) {
                this.checkedPermissions = ['Upload', 'Delete'];
              } else if (row.permission == 7) {
                this.checkedPermissions = ['Download', 'Upload', 'Delete'];
              } else {
                this.checkedPermissions = [];
              }
              if (this.checkedPermissions.length > 0) {
                this.isIndeterminate = true;
              }
              this.formData.permission = row.permission;
              this.formData.createdAt = row.createdAt;
              this.formData.updatedBy = this.userInfo.nickName;
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function editFileRole(_x5) {
        return _editFileRole.apply(this, arguments);
      }
      return editFileRole;
    }(),
    refreshData: function refreshData(row) {
      this.handleExpandChange(null, true);
    },
    batchDelFileRoleFunc: function batchDelFileRoleFunc() {
      var _this2 = this;
      this.$confirm(this.$t('common.delete_warning'), "", {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var selected;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              selected = _this2.selected;
              batchDelFileRoleByIds({
                ids: selected.map(function (item) {
                  return item.ID;
                })
              }).then(function (res) {
                if (res.code === 0) {
                  _this2.$message.success("删除成功");
                }
                _this2.getTableData();
              });
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))).catch(function () {
        _this2.$message({
          type: "info",
          message: _this2.$t('common.cancel')
        });
      });
    },
    deleteFileRoleFunc: function () {
      var _deleteFileRoleFunc = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee9(row) {
        var _this3 = this;
        return regeneratorRuntime.wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              this.$confirm(this.$t('common.delete_warning'), "", {
                confirmButtonText: this.$t('common.confirm'),
                cancelButtonText: this.$t('common.cancel'),
                type: "warning"
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                var res;
                return regeneratorRuntime.wrap(function (_context8) {
                  while (1) switch (_context8.prev = _context8.next) {
                    case 0:
                      _this3.formData.ID = row.ID;
                      _context8.next = 1;
                      return deleteFileRole({
                        ID: row.ID,
                        DeletedBy: _this3.userInfo.nickName
                      });
                    case 1:
                      res = _context8.sent;
                      if (res.code === 0) {
                        _this3.$message.success("删除成功");
                      }
                      _context8.next = 2;
                      return _this3.getTableData();
                    case 2:
                      if (_this3.currentLoadTreeData == null) {
                        _this3.currentLoadTreeData = _this3.formData;
                      }
                    case 3:
                    case "end":
                      return _context8.stop();
                  }
                }, _callee8);
              }))).catch(function () {
                _this3.$message({
                  type: "info",
                  message: _this3.$t('common.cancel')
                });
              });
            case 1:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function deleteFileRoleFunc(_x6) {
        return _deleteFileRoleFunc.apply(this, arguments);
      }
      return deleteFileRoleFunc;
    }(),
    closeDialog: function closeDialog() {
      this.resetForm('ruleForm');
      this.path = "";
      this.formData.ID = null;
      this.formData.name = "";
      this.formData.folderType = null;
      this.dialogFormVisible = false;
      this.formData.groupName = null;
    },
    fileRoleNameValid: function () {
      var _fileRoleNameValid = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee0() {
        var res;
        return regeneratorRuntime.wrap(function (_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              _context0.next = 1;
              return getFileRoleByName(this.formData);
            case 1:
              res = _context0.sent;
              if (!(res.code === 0)) {
                _context0.next = 2;
                break;
              }
              if (!(res.msg !== 'Success')) {
                _context0.next = 2;
                break;
              }
              this.$message({
                type: 'error',
                message: res.msg
              });
              return _context0.abrupt("return", false);
            case 2:
              return _context0.abrupt("return", true);
            case 3:
            case "end":
              return _context0.stop();
          }
        }, _callee0, this);
      }));
      function fileRoleNameValid() {
        return _fileRoleNameValid.apply(this, arguments);
      }
      return fileRoleNameValid;
    }(),
    formValid: function () {
      var _formValid = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee1() {
        var a;
        return regeneratorRuntime.wrap(function (_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              a = null;
              this.$refs['ruleForm'].validate(function (v) {
                a = v;
              });
              return _context1.abrupt("return", a);
            case 1:
            case "end":
              return _context1.stop();
          }
        }, _callee1, this);
      }));
      function formValid() {
        return _formValid.apply(this, arguments);
      }
      return formValid;
    }(),
    addFileRole: function () {
      var _addFileRole = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var res;
        return regeneratorRuntime.wrap(function (_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 1;
              return this.formValid();
            case 1:
              if (_context10.sent) {
                _context10.next = 2;
                break;
              }
              console.log('form invalid');
              return _context10.abrupt("return");
            case 2:
              _context10.next = 3;
              return this.fileRoleNameValid();
            case 3:
              if (_context10.sent) {
                _context10.next = 4;
                break;
              }
              console.log('form name invalid');
              return _context10.abrupt("return");
            case 4:
              _context10.next = 5;
              return createFileRole(this.formData);
            case 5:
              res = _context10.sent;
              if (res.code === 0) {
                this.$message({
                  type: 'success',
                  message: this.$t('common.success')
                });
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                });
              }
              this.path = "";
              _context10.next = 6;
              return this.getTableData();
            case 6:
              this.dialogFormVisible = false;
              this.checkedPermissions = [];
              _context10.next = 7;
              return this.resetForm('ruleForm');
            case 7:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function addFileRole() {
        return _addFileRole.apply(this, arguments);
      }
      return addFileRole;
    }(),
    editButton: function () {
      var _editButton = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var res;
        return regeneratorRuntime.wrap(function (_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 1;
              return updateFileRole(this.formData);
            case 1:
              res = _context11.sent;
              if (res.code === 0) {
                this.$message({
                  type: 'success',
                  message: this.$t('common.success')
                });
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                });
              }
              this.path = "";
              _context11.next = 2;
              return this.resetForm('ruleForm');
            case 2:
              _context11.next = 3;
              return this.getTableData();
            case 3:
              this.dialogFormVisible = false;
              if (this.formData.level == '2') {
                if (this.currentLoadTreeData == null) {
                  this.currentLoadTreeData = this.formData;
                }
                this.refreshData();
              }
              // this.formData = {};
            case 4:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function editButton() {
        return _editButton.apply(this, arguments);
      }
      return editButton;
    }()
  }
};